module.exports = __webpack_public_path__ + "static/img/cwy3.18bcc9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cwy3.png
// module id = C9aI
// module chunks = 73